import { useMutation, useQueryClient } from '@tanstack/react-query';

import { delegateFieldRequest } from '@krea/common/store/field-requests/api';
import { ONE_FIELD_REQUEST_STORE_KEY } from '@krea/common/store/queryClient';

export const useDelegateFieldRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ fieldRequestID, email }) =>
      delegateFieldRequest(fieldRequestID, email),
    onSuccess: async (_, { fieldRequestID }) => {
      await queryClient.invalidateQueries({
        queryKey: [ONE_FIELD_REQUEST_STORE_KEY, fieldRequestID],
      });
    },
    onError: (err) => {
      console.error('Failed delegating field request', err);
    },
  });
};
